module.exports = __webpack_public_path__ + "img/up-cadou-paste.8f68991a.png";